export default __webpack_public_path__ + "static/media/current_location.d3420d1e.svg";